import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.title !== null) {
      params.set("title", this.filters.advanced.title);
    }

    if (this.filters.advanced.service.length > 0) {
      this.filters.advanced.service.forEach((element) =>
        params.append("service", element)
      );
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.beneficiary.length > 0) {
      this.filters.advanced.beneficiary.forEach((element) =>
        params.append("beneficiary", element)
      );
    }

    if (this.filters.advanced.emplOfficerId.length > 0) {
      this.filters.advanced.emplOfficerId.forEach((element) =>
        params.append("emplOfficerId", element)
      );
    }

    if (
      this.filters.advanced.date != null &&
      this.filters.advanced.date.length > 0
    ) {
      const startDate = this.filters.advanced.date[0];
      const endDate = this.filters.advanced.date.at(-1);
      params.set("startDate", formatDateToIsoString(new Date(startDate)));
      params.set("endDate", formatDateToIsoString(new Date(endDate)));
    }

    if (this.filters.advanced.hasCV !== null) {
      params.set("hasCV", this.filters.advanced.hasCV);
    }

    if (this.filters.advanced.relocate !== null) {
      params.set("relocate", this.filters.advanced.relocate);
    }

    if (this.filters.advanced.languages.length > 0) {
      this.filters.advanced.languages.forEach((element) =>
        params.append("languages", element)
      );
    }

    if (this.filters.advanced.languageLevels.length > 0) {
      this.filters.advanced.languageLevels.forEach((element) =>
        params.append("languageLevels", element)
      );
    }

    if (this.filters.advanced.hasDrivingLicense !== null) {
      params.set("hasDrivingLicense", this.filters.advanced.hasDrivingLicense);
    }

    if (this.filters.advanced.drivingLicense !== null) {
      params.set("drivingLicense", this.filters.advanced.drivingLicense);
    }

    if (this.filters.advanced.projects.length > 0) {
      this.filters.advanced.projects.forEach((element) =>
        params.append("project", element)
      );
    }

    return params;
  },

  serviceOverviewRequestQueryParams() {
    const params = new URLSearchParams();

    if (this.serviceOverviewFilters.keyword !== "" && this.serviceOverviewFilters.keyword !== null) {
      params.set("keyword", this.serviceOverviewFilters.keyword);
    }

    if (this.serviceOverviewFilters.advanced.title !== null) {
      params.set("title", this.serviceOverviewFilters.advanced.title);
    }

    if (this.serviceOverviewFilters.advanced.service.length > 0) {
      this.serviceOverviewFilters.advanced.service.forEach((element) =>
        params.append("service", element)
      );
    }

    if (this.serviceOverviewFilters.advanced.branch !== null) {
      params.set("branch", this.serviceOverviewFilters.advanced.branch);
    }

    if (this.serviceOverviewFilters.advanced.beneficiary.length > 0) {
      this.serviceOverviewFilters.advanced.beneficiary.forEach((element) =>
        params.append("beneficiary", element)
      );
    }

    if (this.serviceOverviewFilters.advanced.emplOfficerId.length > 0) {
      this.serviceOverviewFilters.advanced.emplOfficerId.forEach((element) =>
        params.append("emplOfficerId", element)
      );
    }

    if (
      this.serviceOverviewFilters.advanced.date != null &&
      this.serviceOverviewFilters.advanced.date.length > 0
    ) {
      const startDate = this.serviceOverviewFilters.advanced.date[0];
      const endDate = this.serviceOverviewFilters.advanced.date.at(-1);
      params.set("startDate", formatDateToIsoString(new Date(startDate)));
      params.set("endDate", formatDateToIsoString(new Date(endDate)));
    }

    return params;
  },
};
